import styled from "@emotion/styled";

import { DesignToken, Text } from "@livechat/design-system-react-components";

import LinkStyledButton from "components/button/LinkStyledButton";
import { withVar } from "themes/helpers";

export const SectionWrapper = styled.div`
  border-top: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};

  > div {
    border: none;
    margin: 0px;

    > div {
      font-size: 16px;
    }

    div:nth-of-type(2) {
      > div {
        padding-top: 0;
      }
    }
  }
`;

export const TitleWrapper = styled.div`
  font-weight: 600;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
`;

export const StyledTitle = styled.div`
  flex: 1;
  font-size: 14px;
`;

export const UserContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  line-height: 18px;
  margin: 10px 0 12px;
`;

export const UserData = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  flex-direction: column;
  margin-left: 10px;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
  line-height: 20px;
`;

export const SubtitleWrapper = styled.div`
  margin-top: 16px;
  font-weight: 600;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
`;

export const ActionLinkContainer = styled.div`
  margin: 10px 0;
`;

export const StyledLink = styled(LinkStyledButton)`
  margin-left: 10px;
  font-size: 14px;
  font-weight: normal;

  &:hover,
  &:active {
    text-decoration: none;
  }
`;

interface IValue {
  faded?: boolean;
}

export const Value = styled(Text)<IValue>`
  ${({ faded }): string => (faded ? `color: var(${DesignToken.ContentBasicDisabled});` : "")};
  white-space: pre-wrap;
  word-break: break-all;
  word-break: break-word;
`;
